module.exports = __webpack_public_path__ + "media/widget/psych_diagnosis-869c1a0e.png";